import { TableCell, TableRow } from '@client/components/ui/table';

interface TeamTableSkeletonProps {
  rowCount?: number;
}

export function TeamTableSkeleton({ rowCount = 3 }: TeamTableSkeletonProps) {
  return (
    <>
      {Array.from({ length: rowCount }).map((_, idx) => (
        <TableRow key={`skeleton-${idx}`}>
          <TableCell>
            <div className="space-y-2">
              <div className="h-4 w-32 animate-pulse rounded bg-gray-100" />
              <div className="h-3 w-40 animate-pulse rounded bg-gray-50" />
            </div>
          </TableCell>
          <TableCell>
            <div className="h-5 w-16 animate-pulse rounded-full bg-gray-100" />
          </TableCell>
          <TableCell>
            <div className="h-4 w-8 animate-pulse rounded bg-gray-100" />
          </TableCell>
          <TableCell>
            <div className="h-4 w-24 animate-pulse rounded bg-gray-100" />
          </TableCell>
          <TableCell>
            <div className="h-4 w-20 animate-pulse rounded bg-gray-100" />
          </TableCell>
          <TableCell>
            <div className="space-y-2">
              <div className="h-4 w-28 animate-pulse rounded bg-gray-100" />
              <div className="h-3 w-32 animate-pulse rounded bg-gray-50" />
            </div>
          </TableCell>
          <TableCell className="text-right">
            <div className="ml-auto h-8 w-8 animate-pulse rounded bg-gray-100" />
          </TableCell>
        </TableRow>
      ))}
    </>
  );
}
